import LangService from "../../../services/LangService";

const landing = () => {
    const langMap = LangService.map.pages.welcome;

    return ({
        "firstScreen": {
            "title": langMap.title,
            "subtitle": langMap.description,
            "buttonText": langMap.button
        },
        "communityName": "Volee",
        "domain": "volee",
    })
}

export default landing;